var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H48.5C50.7091 0 52.5 1.79086 52.5 4V48.5C52.5 50.7091 50.7091 52.5 48.5 52.5H4C1.79086 52.5 0 50.7091 0 48.5V4ZM15.9216 32.8284C17.4837 31.2663 20.0163 31.2663 21.5784 32.8284L23.4216 34.6716C24.9837 36.2337 27.5163 36.2337 29.0784 34.6716L38.1716 25.5784C40.6914 23.0586 45 24.8432 45 28.4069V41C45 43.2091 43.2091 45 41 45H10.1516C8.68718 45 7.5 43.8128 7.5 42.3483V42.3483C7.5 41.6451 7.77937 40.9706 8.27665 40.4733L15.9216 32.8284ZM20.625 22.5C23.7316 22.5 26.25 19.9816 26.25 16.875C26.25 13.7684 23.7316 11.25 20.625 11.25C17.5184 11.25 15 13.7684 15 16.875C15 19.9816 17.5184 22.5 20.625 22.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgicon);
export default __webpack_public_path__ + "static/media/imgicon.88f1402b7de34316024a8581fab515ee.svg";
export { ForwardRef as ReactComponent };